<template>
  <v-dialog
    persistent
    max-width="500"
    v-model="dialog"
    @keydown.esc="closeModal"
  >
    <v-card>
      <v-card-title>
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeModal">Annuler</v-btn>
        <v-btn text @click="sendDeleteEvent" color="red">Supprimer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from "vue";
import { computed } from "@vue/composition-api";

export default Vue.extend({
  name: "DeleteDialog",
  props: {
    open: Boolean,
  },
  setup(props, { emit }) {
    const dialog = computed(function () {
      return props.open;
    });
    const closeModal = function () {
      emit("update:open", false);
    };
    const sendDeleteEvent = function () {
      emit("delete");
      closeModal();
    };

    return {
      dialog,
      closeModal,
      sendDeleteEvent,
    };
  },
});
</script>
